export const AllStatuses = (props) => (
  <svg
    style={{ ...props?.style }}
    width='28'
    height='8'
    viewBox='0 0 28 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='8' height='8' rx='4' fill='inherit' />
    <rect x='10' width='8' height='8' rx='4' fill='inherit' />
    <rect x='20' width='8' height='8' rx='4' fill='inherit' />
  </svg>
);
